export type TileColor = 'black' | 'red' | 'blue' | 'orange';

export const TILE_COLORS: readonly TileColor[] = ['black', 'red', 'blue', 'orange'] as const;

export const MIN_NUMBER = 1;
export const MAX_NUMBER = 13;
export const JOKER_SCORE = 30;
export const INITIAL_MELD_THRESHOLD = 30;
export const ROLLBACK_PENALTY_DRAW = 3;
export const MAX_JOKERS_PER_MELD = 2;
export const MIN_MELD_SIZE = 3;
export const MAX_GROUP_SIZE = 4;

export interface Tile {
  /** 唯一 ID（防偽、DnD key） */
  id: string;
  color: TileColor | null;
  number: number | null;
  isJoker: boolean;
}

export type Meld = Tile[];

export interface GameSettings {
  turnTimeLimit: 30 | 60 | 90 | 120;
  isPublic: boolean;
  /** 破冰時百搭以被替代牌面值計分；預設 true（官方規則） */
  allowJokerInInitialMeld: boolean;
  /** 超時罰抽張數：1 或 3（預設 3，官方規則） */
  timeoutPenalty: 1 | 3;
}

export const DEFAULT_SETTINGS: GameSettings = {
  turnTimeLimit: 60,
  isPublic: false,
  allowJokerInInitialMeld: true,
  timeoutPenalty: 3,
};

export type PlayerRole = 'PLAYER' | 'SPECTATOR';
export type PlayerConnState = 'ONLINE' | 'OFFLINE';
export type GameStatus = 'WAITING' | 'PLAYING' | 'FINISHED';

export interface Player {
  id: string;
  name: string;
  avatarUrl: string;
  role: PlayerRole;
  rack: Tile[];
  status: PlayerConnState;
  hasMelted: boolean;
  score: number;
  points: number;
}

export interface MeldPos {
  row: number;
  col: number;
}

export interface BoardSnapshot {
  board: Meld[];
  boardLayout?: MeldPos[];
  playerRack: Tile[];
  hasMelted: boolean;
}

export interface GameState {
  roomId: string;
  hostId: string;
  settings: GameSettings;
  status: GameStatus;
  turnOrder: string[];
  players: Player[];
  board: Meld[];
  /** 與 board 同序對應的 (row, col) 位置；client 拖曳產生，由 server 廣播 */
  boardLayout: MeldPos[];
  pool: Tile[];
  currentTurnPlayerId: string;
  turnVersion: number;
  turnStartTime: number;
  turnInitialState: BoardSnapshot;
  turnJokersTakenBack: string[];
  turnActionStack: BoardSnapshot[];
  consecutivePassCount: number;
  /**
   * 最後一回合倒數。
   * null = 牌堆尚未耗盡。
   * 牌堆首次歸零時設為 players.length，之後每完成一回合 -1；歸 0 強制 FINISHED。
   */
  lastRoundCounter: number | null;
}
